import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from 'routes';

/**
 * Custom hook to manage tab routing and active tab state
 *
 * @param {Array} tabOptions - Array of tab configuration objects
 * @returns {Object} Tab state and utilities
 */
export const useTabRouting = (tabOptions) => {
    const location = useLocation();

    // Map routes to tab options
    const routeToTabMap = useMemo(() => ({
        [routes.GatewayManagementSmartSensorDCU]: 0,
        [routes.GatewayManagementSmartSensor]: 1,
        [routes.GatewayManagementAPP]: 2,
        [routes.GatewayManagementDriveDCU]: 3
    }), []);

    // Find active tab based on current location
    const activeTabIndex = useMemo(() => {
        const currentRoute = Object.keys(routeToTabMap).find(route =>
            location.pathname.startsWith(route)
        );
        return routeToTabMap[currentRoute] ?? 0;
    }, [location.pathname, routeToTabMap]);

    // Get current tab configuration
    const currentTab = useMemo(() => {
        return activeTabIndex >= 0 ? tabOptions[activeTabIndex] : null;
    }, [activeTabIndex, tabOptions]);

    // Tab route mapping
    const tabRoutes = useMemo(() => [
        routes.GatewayManagementSmartSensorDCU,
        routes.GatewayManagementSmartSensor,
        routes.GatewayManagementAPP,
        routes.GatewayManagementDriveDCU
    ], []);

    return {
        activeTabIndex,
        currentTab,
        tabRoutes,
        routeToTabMap
    };
};
